/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateCommercialEmailConsentRequest interface.
 */
export function instanceOfUpdateCommercialEmailConsentRequest(value) {
    if (!('consented' in value) || value['consented'] === undefined)
        return false;
    return true;
}
export function UpdateCommercialEmailConsentRequestFromJSON(json) {
    return UpdateCommercialEmailConsentRequestFromJSONTyped(json, false);
}
export function UpdateCommercialEmailConsentRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clauseVersion': json['clauseVersion'] == null ? undefined : json['clauseVersion'],
        'consented': json['consented'],
    };
}
export function UpdateCommercialEmailConsentRequestToJSON(json) {
    return UpdateCommercialEmailConsentRequestToJSONTyped(json, false);
}
export function UpdateCommercialEmailConsentRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'clauseVersion': value['clauseVersion'],
        'consented': value['consented'],
    };
}
